import React from 'react';
import { CtaButton } from './CtaButton';
import { PaymentNote } from './PaymentNote';
import { PriceTag } from './PriceTag';
import { OfferCountdown } from './OfferCountdown';
import { checkoutUrl, closingSteps, thirtyDayOutcomes } from '../data/kit';
export function FinalCta() {
  return <section className="w-full bg-ink text-white" aria-labelledby="final" data-id="element-109" data-mp="15cu96hq0ghh4">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-28" data-id="element-110" data-mp="1jd52dresm85g">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-111" data-mp="1jbk90547sv96">
          <div data-id="element-112" data-mp="1eetsxhsetznr">
            <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-113" data-mp="1ed0h7o2xwp8w">
              Dentro de 30 días podés seguir buscando…
            </h2>
            <p className="mt-4 text-lg text-white/70" data-id="element-114" data-mp="1o3vavdiimr4d">O podés haber:</p>
          </div>
          <div data-id="element-115" data-mp="1o67ojeh8qfbm">
            <ul className="flex flex-wrap gap-2" data-id="element-116" data-mp="223d01tzq46e9">
              {thirtyDayOutcomes.map(item => <li key={item} className="rounded-full border border-white/20 px-4 py-2 text-white/90" data-id="element-117" data-mp="1x4taljlx8ch5">
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 text-lg text-white/70" data-id="element-118" data-mp="s4pc3ov18eaw">y aprendido algo que ningún video podía enseñarte:</p>
            <p className="mt-1 font-display text-2xl font-black text-cta sm:text-3xl" data-id="element-119" data-mp="x41y67e2xhcf">Qué pasa cuando vos lo intentás.</p>
          </div>
        </div>

        <div className="mt-20 rounded-[2rem] bg-surface px-6 py-12 text-center text-ink sm:px-12" data-id="element-120" data-mp="124g8xx72f5e5">
          <h2 id="final" className="font-display text-4xl font-black uppercase tracking-tight sm:text-5xl" data-id="element-121" data-mp="163xeeqmhs2jb">
            Kit Ingresos Online
          </h2>
          <p className="mt-2 text-lg text-muted" data-id="element-122" data-mp="1fujknu8bjgpc">3 modelos reales para empezar desde Argentina.</p>
          <p className="mt-5 font-display text-lg font-extrabold tracking-wide" data-id="element-123" data-mp="1kt38y1adx4kv">
            <span className="text-airbnb" data-id="element-124" data-mp="1psfy4soqanqm">AIRBNB</span> · <span className="text-arbitraje" data-id="element-125" data-mp="1pthcb611jqck">ARBITRAJE</span> ·{' '}
            <span className="text-digital" data-id="element-126" data-mp="1ttroj0fffczv">PRODUCTOS DIGITALES</span>
          </p>
          <p className="mt-2 font-display font-extrabold text-ink" data-id="element-127" data-mp="3quovmq3gulmr">+ 3 bonos exclusivos</p>
          <div className="mt-6" data-id="element-128" data-mp="3qsb1qkkivfgs">
            <PriceTag size="lg" align="center" data-id="element-129" data-mp="3lw44rha3teaz" />
          </div>
          <p className="mt-1 text-muted" data-id="element-130" data-mp="3ltre8fqa5vmb">Pago único · Acceso digital</p>
          <div className="mx-auto mt-6 max-w-md" data-id="element-131" data-mp="3j5yytqmrr8w">
            <OfferCountdown data-id="element-132" data-mp="3uwissoegd7i6" />
          </div>
          <div className="mx-auto mt-5 max-w-md" data-id="element-133" data-mp="3uupmja7r4pap">
            <CtaButton label="Sí, quiero empezar" href={checkoutUrl} fullWidth data-id="element-134" data-mp="dfiuzy9neh6t" />
          </div>
          <div className="mt-4" data-id="element-135" data-mp="8gy3cn8gp5tz">
            <PaymentNote data-id="element-136" data-mp="8fmqzz0yapr9" />
          </div>
        </div>

        <div className="mt-20 text-center" data-id="element-137" data-mp="mggxud8coint">
          <p className="font-display text-3xl font-black sm:text-4xl" data-id="element-138" data-mp="mf5w0iygtkzc">Dejá de coleccionar ideas.</p>
          <p className="mt-2 font-display text-3xl font-black text-cta sm:text-4xl" data-id="element-139" data-mp="ig6u778164c4">{closingSteps.join(' ')}</p>
          <p className="mt-6 text-lg text-white/70" data-id="element-140" data-mp="2o8c6ejzb871t">Tu próxima fuente de ingresos puede empezar con tu primer paso.</p>
        </div>
      </div>
    </section>;
}